<template>
  <a-link :to="ROUTE_NAME.PREMIUM" aria-label="Go to investingLive Premium">
    <div class="premium-banner__wrapper">
      <a-image
        :src="$helper.getLinkToIlBucketFile('premium-banner-il-v3_small.png')"
        :alt="$options.consts.altText"
        class="premium-banner__image-sm"
      />
      <div class="premium-banner__text">
        <div class="premium-banner__title text-small">
          Telegram Community
        </div>
        <div class="premium-banner__subtitle text-body">
          Gain Access
        </div>
      </div>
    </div>
  </a-link>
</template>

<script>
import { ROUTE_NAME } from 'enums/routes'

export default {
  name: 'PremiumBanner',
  consts: {
    altText: 'investingLive Premium'
  },
  data() {
    return {
      ROUTE_NAME
    }
  }
}
</script>

<style lang="scss" scoped>
.premium-banner__wrapper {
  margin-top: 24px;
  border-radius: 4px;
  display: flex;
  height: 100px;
  overflow: hidden;

  .premium-banner__image-sm {
    width: 100px;
    height: 100px;
    flex-shrink: 0;
  }

  .premium-banner__text {
    height: 100%;
    background: $c--black;
    padding: 26px 24px 26px 16px;
    flex: 1;
  }

  .premium-banner__title {
    line-height: 16px;
    color: $c--gray-light;
    margin-bottom: 8px;
  }

  .premium-banner__subtitle {
    color: $c--white;
  }
}
</style>
